import { nsUser } from '@/app/i18n/namespaces';

const USER_ADVANCED_AUTH = {
    ENABLED: { name: 'ENABLED', entity: 'has_mfa.ENABLED', value: true, namespace: nsUser },
    DISABLED: { name: 'DISABLED', entity: 'has_mfa.DISABLED', value: false, namespace: nsUser }
};

export default USER_ADVANCED_AUTH;